import { render, staticRenderFns } from "./TreeCo2Progress.vue?vue&type=template&id=2626584b&scoped=true&"
import script from "./TreeCo2Progress.vue?vue&type=script&lang=ts&"
export * from "./TreeCo2Progress.vue?vue&type=script&lang=ts&"
import style0 from "./TreeCo2Progress.vue?vue&type=style&index=0&id=2626584b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2626584b",
  null
  
)

export default component.exports